module.exports = __webpack_public_path__ + "static/media/ascending-sort.b0541ae3.png";